import { render, staticRenderFns } from "./TaskSvg.vue?vue&type=template&id=34d76e82"
import script from "./TaskSvg.vue?vue&type=script&lang=js"
export * from "./TaskSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports